import React from 'react';
import { Link } from 'react-router-dom';

const ProjectHeader = ({ project }) => {
  return (
    <>
      {/* Add Back Link */}
      <div className="mb-12 px-4">
        <Link
          to="/projects" 
          className="group inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors duration-200 text-lg"
        >
          <span className="transform transition-transform duration-300 -translate-y-0.5 group-hover:-translate-x-1">
          ‹
          </span>
          All Projects
        </Link>
      </div>
      <header className="mb-16">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-baseline mb-20 px-4">
        <h1 className="text-4xl md:text-8xl font-light text-gray-900 mb-6 md:mb-0">
          {project.name}
        </h1>
        {project.websiteUrl && (
          <a
            href={project.websiteUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="group relative inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 
                      transition-colors duration-200 text-lg pb-1"
          >
            Visit Website
            <span className="inline-block transform transition-transform 
                            duration-500 group-hover:translate-x-1 group-hover:-translate-y-1">
              ↗
            </span>
            
            {/* Minimalist underline animation */}
            <span className="absolute bottom-0 left-0 w-0 h-px bg-gray-300
                           transition-all duration-300 ease-out 
                           group-hover:w-full origin-left"></span>
          </a>
        )}
      </div>

      {/* Rest of the component remains unchanged */}
      <div className="grid md:grid-cols-3 gap-48 pt-8 px-24">
        {/* Tech Stack Column */}
        <div className="px-4">
          <h3 className="text-xs text-gray-500 font-medium mb-4 uppercase tracking-wider">
            Technology
          </h3>
          <ul className="space-y-2">
            {project.techStack.map((tech, index) => (
              <li 
                key={index}
                className="text-gray-600 text-lg font-light"
              >
                {tech}
              </li>
            ))}
          </ul>
        </div>

        {/* Collaborators Column */}
        <div className="px-4">
          <h3 className="text-xs text-gray-500 font-medium mb-4 uppercase tracking-wider">
            Team
          </h3>
          <ul className="space-y-4">
            {project.collaborators.map((collaborator, index) => (
              <li key={index}>
                <p className="text-gray-600 text-lg font-light">
                  <span className="block text-gray-400 text-sm">
                    {collaborator.role}
                  </span>
                  {collaborator.name}
                </p>
              </li>
            ))}
          </ul>
        </div>

        {/* Location Column */}
        <div className="px-4">
          <h3 className="text-xs text-gray-500 font-medium mb-4 uppercase tracking-wider">
            Details
          </h3>
          <p className="text-gray-600 text-lg font-light">
            {project.location}
            <span className="block text-gray-400 mt-1">
              {project.year}
            </span>
          </p>
        </div>
      </div>
    </header>
    </>
  );
};

export default ProjectHeader;